import { Revoked as RevokedImage } from "@rshbintech.dboul/images";
import { Button, Heading, Text } from "@rshbintech.dboul/core-ui";
import { ErrorContentProps } from "./types";
import { ERROR_CONTENT } from "./constants";
import styles from "./styles.scss";

export const ErrorContent = ({ onBack, onRetry }: ErrorContentProps) => (
  <div className={styles.container}>
    <RevokedImage className={styles.image} />
    <Heading className={styles.title} level={3}>
      {ERROR_CONTENT.TITLE}
    </Heading>
    <Text className={styles.description}>{ERROR_CONTENT.DESCRIPTION}</Text>
    <div className={styles["buttons-block"]}>
      <Button
        className={styles["button-back"]}
        htmlType="button"
        type="outline-neutral"
        onClick={onBack}
      >
        {ERROR_CONTENT.BUTTON.BACK}
      </Button>
      <Button
        className={styles["button-retry"]}
        htmlType="button"
        onClick={onRetry}
      >
        {ERROR_CONTENT.BUTTON.RETRY}
      </Button>
    </div>
  </div>
);
